/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyDescription {
    getFixupPrototypeFunction() { return PolicyDescription.fixupPrototype; }

    static newInstance(model: Partial<PolicyDescription>): PolicyDescription {
        let obj = Object.assign(new PolicyDescription(), model);
        PolicyDescription.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyDescription>): PolicyDescription {
        if (!model) return null;
        return PolicyDescription.newInstance(<PolicyDescription> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyDescription) {
        if (!obj) return;

        models.PolicyDescription.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyDescription): boolean {
        Object.setPrototypeOf(obj, PolicyDescription.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (this.parameters) {
            for (let val of this.parameters) {
                models.NamedParameter.fixupPrototype(val);
            }
        }
        if (this.recommendation_actions) {
            for (let val of this.recommendation_actions) {
                models.PolicyRecommendationActions.fixupPrototype(val);
            }
        }
    }

    /**
     * Unique URI for policy
     */
    uri: string;

    /**
     * Policy Id is unique identifier of a policy
     */
    policy_id: string;

    /**
     * Policy name is unique identifier of a policy
     */
    name: string;

    /**
     * Display name of the policy
     */
    display_name: string;

    /**
     * A brief explanation of the policy
     */
    description: string;

    parameters: Array<models.NamedParameter>;

    created_at: Date;

    services: Array<models.PolicyServiceName>;

    /**
     * Engine type of the policy
     */
    engine_type: models.PolicyEngineType;

    /**
     * Scope of the policy
     */
    scope: models.PolicyScope;

    /**
     * ID of the tenant within the CoreStack account
     */
    tenant_id: string;

    /**
     * Id of the CoreStack account under which this tenant resides.
     */
    account_id: string;

    /**
     * Policies are classified based on the basis of the activity they perform. For example: Provisioning, Account Management, Utilization, etc.
     */
    classification: string;

    /**
     * Sub classification for policy
     */
    sub_classification: string;

    /**
     * Category of resource
     */
    resource_category: string;

    /**
     * Type of resource
     */
    resource_type: string;

    /**
     * Service resources of policy
     */
    service_resources: Array<string>;

    /**
     * Severity of policy
     */
    severity: models.PolicySeverityRisk;

    /**
     * Recommendation description of the policy
     */
    recommendation_description: string;

    /**
     * Recommendation actions of the policy
     */
    recommendation_actions: Array<models.PolicyRecommendationActions>;

    /**
     * Equivalent policy names
     */
    equivalent_policies: Array<string>;

}
